import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { TrailheadInView } from '../types/Trailhead';

export type TrailheadUiState = {
  hoveredConnectedTrailId: number | undefined;
  hoveredTrailheadId: TrailheadInView['id'] | undefined;
  isConnectedTrailsTabActive: boolean;
  showConnectedTrailRouteLines: boolean;
  trailheadsInView: TrailheadInView[];
};

export const initialState: TrailheadUiState = {
  hoveredConnectedTrailId: undefined,
  hoveredTrailheadId: undefined,
  isConnectedTrailsTabActive: false,
  showConnectedTrailRouteLines: true,
  trailheadsInView: []
};

const trailheadSlice = createSlice({
  name: 'trailhead',
  initialState,
  reducers: {
    setConnectedTrailsTabActive: (state, action: PayloadAction<boolean>) => {
      state.isConnectedTrailsTabActive = action.payload;
      if (!action.payload) {
        state.hoveredConnectedTrailId = undefined;
      }
    },
    setHoveredConnectedTrailId: (state, action: PayloadAction<number | undefined>) => {
      state.hoveredConnectedTrailId = action.payload;
    },
    setHoveredTrailheadId: (state, action: PayloadAction<TrailheadInView['id'] | undefined>) => {
      state.hoveredTrailheadId = action.payload;
    },
    setShowConnectedTrailRouteLines: (state, action: PayloadAction<boolean>) => {
      state.showConnectedTrailRouteLines = action.payload;
    },
    setTrailheadsInView: (state, action: PayloadAction<TrailheadInView[]>) => {
      state.trailheadsInView = action.payload;
    }
  }
});

export const {
  setConnectedTrailsTabActive,
  setHoveredConnectedTrailId,
  setHoveredTrailheadId,
  setShowConnectedTrailRouteLines,
  setTrailheadsInView
} = trailheadSlice.actions;
export default trailheadSlice.reducer;
